module.exports = __webpack_public_path__ + "f85366a39236cca7471f519bb1bd924a.png";